

















import { Vue, Component, Prop } from 'vue-property-decorator'

import { ChangeEvent } from '@revas/reef'
import { App } from '../../models'

@Component
export default class AppFavoriteAppsTabs extends Vue {
  @Prop() apps!: App[]
  @Prop() value!: string

  getStyle (app: App) {
    const parsedUrl = new URL(app.url)
    const active = this.value === parsedUrl.pathname

    return {
      'reef-font-default reef-font-medium reef-text-sm reef-px-3 reef-py-1 reef-rounded-tab-radius reef-mr-2 reef-cursor-pointer reef-shadow-tab-shadow': true,
      'reef-bg-default-tab-background hover:reef-bg-default-tab-background-hover reef-text-default-tab-label reef-border reef-border-default-tab-background-hover': !active,
      'reef-bg-default-tab-active-background reef-shadow-tab-shadow hover:reef-bg-default-tab-active-background-hover reef-text-default-tab-active-label': active
    }
  }

  onClick (app: App) {
    const event: ChangeEvent<App> = {
      value: app,
      oldValue: null
    }
    this.$emit('change', event)
  }
}
